<template>
	<div class="d-flex flex-column sticky-footer-wrapper">
		<main class="flex-fill">
			<app-header></app-header>
			<message-component></message-component>
			<div class="container mt-3">
				<div class="row">
					<div class="col-md-12">
						<router-view></router-view>
						<div class="card panel-warning d-none d-sm-flex" id="reset-store-panel" v-if="showTestPanel">
							<div class="card-header">Admin Panel (Testing purpose)</div>
							<div class="card-body text-center">
								<button class="btn btn-warning">Reset Store</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>

		<footer class="navbar-default navbar-bottom navbar-dark bg-dark">
			<div class="container-fluid">
				<p class="text-center nav-bar mb-0">Checkout repository at <a
						href="https://bitbucket.org/ranmaru74/dotory/src/master" target="_blank">
					https://bitbucket.org/ranmaru74/dotory/src/master
				</a></p>
			</div>
		</footer>
	</div>

</template>

<script>
	import Header from './components/Header.vue';
	import MessageComponent from './components/common/MessageComponent.vue';

	export default {
		data() {
			return {
				showTestPanel: false
			}
		},
		components: {
			appHeader: Header,
			MessageComponent
		}
	}
</script>

<style>
	#reset-store-panel {
		position: fixed;
		bottom: 0px;
		right: 0px;
	}

	body, .sticky-footer-wrapper {
		min-height: 100vh;
	}

	.flex-fill {
		flex: 1 1 auto;
	}

	footer {
		height: 40px;
		color: #666;
		padding: 10px 0 10px 0;
		font-size: 85%;
	}

	footer a {
		color: #999;
	}

	footer a:hover {
		color: #efefef;
	}

	@media (max-width: 576px) {
		footer {
			height: 50px;
		}
	}
</style>
